/*
 * ERW CART-006: Nuolaidos kodo laukelis krepselyje.
 * Naudoja Cart AJAX API (/cart/update.js su "discount" parametru).
 * Kodai pritaikomi dar krepselyje (matosi kaina su nuolaida) ir persikelia i Checkout.
 * Veikia ir /cart puslapyje, ir cart-notification isssokanciame langelyje.
 *
 * Mygtukas yra type="button", Enter tvarkomas atskirai su preventDefault,
 * kad jokiu budu nebutu native form submit / puslapio persikrovimo.
 */
if (!customElements.get('erw-cart-discount')) {
  class ERWCartDiscount extends HTMLElement {
    constructor() {
      super();
      this._init = false;
      this._busy = false;
    }

    connectedCallback() {
      if (this._init) return;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._init) return;
      this.input = this.querySelector('.erw-discount__input');
      this.button = this.querySelector('.erw-discount__btn');
      if (!this.input || !this.button) return;
      this._init = true;
      this.form = this.querySelector('.erw-discount__form');
      this.message = this.querySelector('.erw-discount__message');
      this.codesList = this.querySelector('.erw-discount__codes');
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.apply();
      });
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.apply();
        }
      });
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.apply();
        });
      }
      if (this.codesList) this.codesList.addEventListener('click', this.onCodesClick.bind(this));
      this.refreshChips();
    }

    getCartUrl() {
      return (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    }

    // Kai kurie app'ai (pvz. PageFly / cart upsell) perrasho window.fetch ir
    // perkrauna puslapi pastebeje krepselio pakeitima. Kad musu AJAX veiktu
    // sklandziai (be reload), krepselio uzklausoms naudojam nepaliesta (native)
    // fetch is atskiro iframe konteksto.
    nf(path, opts) {
      const url = (path.charAt(0) === '/') ? (location.origin + path) : path;
      try {
        if (!this._nfFn) {
          let ifr = document.getElementById('erw-native-fetch-frame');
          if (!ifr) {
            ifr = document.createElement('iframe');
            ifr.id = 'erw-native-fetch-frame';
            ifr.setAttribute('aria-hidden', 'true');
            ifr.setAttribute('tabindex', '-1');
            ifr.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
            document.body.appendChild(ifr);
          }
          const f = ifr.contentWindow && ifr.contentWindow.fetch;
          if (f && f.toString().includes('[native code]')) {
            this._nfFn = f.bind(ifr.contentWindow);
          }
        }
      } catch (e) { /* fall back below */ }
      const fn = this._nfFn || window.fetch;
      return fn(url, opts);
    }

    async getCart() {
      const r = await this.nf('/cart.js', { headers: { Accept: 'application/json' } });
      return r.json();
    }

    async applyCodes(codes) {
      const body = JSON.stringify({ discount: codes.join(',') });
      const r = await this.nf('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body
      });
      return r.json();
    }

    setMessage(text, type) {
      if (!this.message) return;
      this.message.textContent = text || '';
      this.message.classList.remove('is-error', 'is-success');
      if (type) this.message.classList.add('is-' + type);
    }

    setLoading(state) {
      if (this.button) this.button.toggleAttribute('disabled', state);
      this.classList.toggle('is-loading', state);
    }

    async apply() {
      if (this._busy) return;
      const code = (this.input.value || '').trim();
      if (!code) return;
      this._busy = true;
      this.setLoading(true);
      this.setMessage('', null);
      try {
        const cart = await this.getCart();
        const existing = (cart.discount_codes || []).filter((c) => c.applicable).map((c) => c.code);
        const already = existing.some((c) => c.toLowerCase() === code.toLowerCase());
        const attempt = already ? existing : existing.concat([code]);
        const resp = await this.applyCodes(attempt);
        const codesArr = resp.discount_codes || [];
        const entered = codesArr.find((c) => c.code.toLowerCase() === code.toLowerCase());
        if (entered && entered.applicable) {
          const finalCodes = codesArr.filter((c) => c.applicable).map((c) => c.code);
          if (codesArr.some((c) => !c.applicable)) await this.applyCodes(finalCodes);
          this.input.value = '';
          this.setMessage(await this.savedText(), 'success');
          await this.rerenderCartSections();
          await this.refreshChips();
        } else {
          const finalCodes = codesArr.filter((c) => c.applicable).map((c) => c.code);
          await this.applyCodes(finalCodes);
          this.setMessage('Kodas negalioja arba netinka šiam krepšeliui', 'error');
          await this.refreshChips();
        }
      } catch (err) {
        console.error('[ERW discount]', err);
        this.setMessage('Įvyko klaida, bandykite dar kartą', 'error');
      } finally {
        this._busy = false;
        this.setLoading(false);
      }
    }

    async onCodesClick(e) {
      const btn = e.target.closest('button[data-remove-code]');
      if (!btn) return;
      e.preventDefault();
      if (this._busy) return;
      this._busy = true;
      this.setLoading(true);
      try {
        const codeToRemove = btn.getAttribute('data-remove-code');
        const cart = await this.getCart();
        const remaining = (cart.discount_codes || [])
          .filter((c) => c.applicable && c.code.toLowerCase() !== codeToRemove.toLowerCase())
          .map((c) => c.code);
        await this.applyCodes(remaining);
        this.setMessage('', null);
        await this.rerenderCartSections();
        await this.refreshChips();
      } catch (err) {
        console.error('[ERW discount]', err);
      } finally {
        this._busy = false;
        this.setLoading(false);
      }
    }

    async savedText() {
      try {
        const cart = await this.getCart();
        if (cart.total_discount && cart.total_discount > 0) {
          return 'Nuolaida pritaikyta. Sutaupote ' + this.formatMoney(cart.total_discount);
        }
      } catch (e) {}
      return 'Nuolaida pritaikyta';
    }

    formatMoney(cents) {
      try {
        const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        return (cents / 100).toLocaleString('lt-LT', { style: 'currency', currency: cur });
      } catch (e) {
        return (cents / 100).toFixed(2) + ' EUR';
      }
    }

    async refreshChips() {
      if (!this.codesList) return;
      let cart;
      try { cart = await this.getCart(); } catch (e) { return; }
      const codes = (cart.discount_codes || []).filter((c) => c.applicable);
      this.codesList.innerHTML = codes
        .map((c) => {
          const code = this.escape(c.code);
          return (
            '<li class="erw-discount__chip"><span>' + code + '</span>' +
            '<button type="button" data-remove-code="' + code + '" aria-label="Pašalinti kodą ' + code + '">&times;</button></li>'
          );
        })
        .join('');
    }

    escape(s) {
      return String(s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
    }

    async rerenderCartSections() {
      const map = [
        ['main-cart-items', '.js-contents'],
        ['main-cart-footer', '.js-contents'],
        ['cart-icon-bubble', null]
      ];
      const present = map.filter((pair) => document.getElementById(pair[0]));
      if (!present.length) return;
      const base = this.getCartUrl();
      await Promise.all(
        present.map(async (pair) => {
          const id = pair[0];
          const selector = pair[1];
          const cur = document.getElementById(id);
          // Section Rendering API reikia temos section ID (is data-id), ne elemento ID.
          const sectionId = (cur && cur.dataset && cur.dataset.id) ? cur.dataset.id : id;
          try {
            const html = await this.nf(base + '?section_id=' + encodeURIComponent(sectionId)).then((r) => r.text());
            const doc = new DOMParser().parseFromString(html, 'text/html');
            if (!cur) return;
            if (selector) {
              const src = doc.getElementById(id) ? doc.getElementById(id).querySelector(selector) : doc.querySelector(selector);
              const dst = cur.querySelector(selector);
              if (src && dst) dst.innerHTML = src.innerHTML;
            } else {
              const src = doc.getElementById(id) || doc.body;
              cur.innerHTML = src.innerHTML;
            }
          } catch (e) {
            console.error('[ERW discount] rerender', id, e);
          }
        })
      );
    }
  }

  customElements.define('erw-cart-discount', ERWCartDiscount);
}
